import * as React from "react";

const CheckCircle: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="currentColor"
            stroke="none"
        >
            <path d="M18.3331 10C18.3331 14.6024 14.6021 18.3334 9.99977 18.3334C5.3974 18.3334 1.66644 14.6024 1.66644 10C1.66644 5.39765 5.3974 1.66669 9.99977 1.66669C14.6021 1.66669 18.3331 5.39765 18.3331 10ZM3.33311 10C3.33311 13.6819 6.31788 16.6667 9.99977 16.6667C13.6817 16.6667 16.6664 13.6819 16.6664 10C16.6664 6.31813 13.6817 3.33336 9.99977 3.33336C6.31788 3.33336 3.33311 6.31813 3.33311 10Z" />
            <path d="M8.75 14.1667L15 8.08561L13.5417 6.66669L8.75 11.3289L6.45833 9.09913L5 10.518L8.75 14.1667Z" />
        </svg>
    );
};

export default React.memo(CheckCircle);
